<template>
  <sa-page-layout :btnSaveVisible="btnSaveVisible" :btnAnnullaVisible="true" :linkback="linkback" :pathResource="pathResource" :data="jsonData" :showModalLoading="showModalLoading" class="sa-no-space">
    <template slot="table-body">
      <gestione-attivita-clienti-edit-component ref="cmpGestioneAttivitaClientiEditComponent" @updateJsonData="onUpdateJsonData"></gestione-attivita-clienti-edit-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GestioneAttivitaClientiEditComponent from "../components/GestioneAttivitaClientiEditComponent.vue";
export default {
  components: { GestioneAttivitaClientiEditComponent, SaPageLayout },
  data() {
    return {
      btnSaveVisible: true,
      showModalLoading: false,
      linkback: "/gestioneattivita/clienti",
      pathResource: "/gestioneattivitaclienti",
      jsonData: null,
    };
  },
  mounted() {
    this.$refs.cmpGestioneAttivitaClientiEditComponent.init();
  },
  methods: {
    onUpdateJsonData(jsonData) {
      this.jsonData = jsonData;
    },
  },
};
</script>

<style></style>
